/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NotifyCustomerPage = lazyLoad(
  () => import('./index'),
  module => module.NotifyEntityPage
);
